import { render, staticRenderFns } from "./referrer-custom-fields.vue?vue&type=template&id=7bd1c0e3"
import script from "./referrer-custom-fields.vue?vue&type=script&lang=js"
export * from "./referrer-custom-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports